export const creator_MQ5JRF5B = {
  custom_button_label: {
    recurring: 'View plans',
  }
};